export const tokenizeNotificationMessage = (
  text,
  { brandName, eventName } = {}
) => {
  if (!text) return [{ type: 'text', value: '' }];

  const entities = [];
  if (brandName) entities.push({ type: 'brand', label: brandName });
  if (eventName) entities.push({ type: 'event', label: eventName });

  const parts = [];
  let cursor = 0;

  while (true) {
    let nextIdx = null;
    let entIdx = -1;

    for (let i = 0; i < entities.length; i++) {
      const e = entities[i];
      if (e.used) continue;
      const idx = text.indexOf(e.label, cursor);
      if (idx !== -1 && (nextIdx === null || idx < nextIdx)) {
        nextIdx = idx;
        entIdx = i;
      }
    }

    if (nextIdx === null) break;

    if (nextIdx > cursor) {
      parts.push({ type: 'text', value: text.slice(cursor, nextIdx) });
    }

    const e = entities[entIdx];
    e.used = true;
    parts.push({ type: entities[entIdx].type, value: e.label });

    cursor = nextIdx + e.label.length;
  }

  if (cursor < text.length)
    parts.push({ type: 'text', value: text.slice(cursor) });

  return parts;
};
